import { Alert, Box } from '@mui/material'
import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useGetNotification, useGetOrder, useGetPayloadMetaData } from '../../../../logic/useApiQuery'
import { useNotificationContentOverride } from '../../../context/notification-content-override/NotificationContentOverrideContext'
import { LoadingScreen } from '../../LoadingScreen'
import { CashToCloseEnterMoreOrComplete } from './CashToCloseEnterMoreOrComplete'
import { CashToCloseTransactionsSummary } from './CashToCloseTransactionsSummary'
import { checkIfPastDue } from '../../../../utils'
import { PayloadProcessingStateProvider } from '../../../context/payload-processing-state/PayloadProcessingState'
import dayjs from 'dayjs'

export function CashToCloseTask() {
  const { closingId, id } = useParams()
  const { search } = useLocation()
  const { data: notification } = useGetNotification(closingId ?? '', id ?? '', search ?? '')
  const { data: orderData } = useGetOrder(closingId ?? '', search ?? '')
  const { isLoading: getPayloadMetaDataLoading } = useGetPayloadMetaData(closingId ?? '', id ?? '', search ?? '', { useErrorBoundary: true})

  const dueDate = dayjs(orderData?.Order?.CashToCloseDetails?.dueDate).format('dddd, MMMM D, YYYY [at] hh:mm A z') || ''
  const pastDue = !notification?.IsComplete && !!orderData?.Order?.CashToCloseDetails?.dueDate && checkIfPastDue(orderData.Order.CashToCloseDetails.dueDate)
  const cashToCloseContextText = notification?.Content + '  This payment must be submitted by: <strong>' + dueDate + '</strong>.  A processing fee of $50 will be added to each payment.'

  const { setNotificationContentOverride } = useNotificationContentOverride()

  const shouldInitiatePayment = !(notification && notification.IsComplete)

  useEffect(() => {
    setNotificationContentOverride(cashToCloseContextText)
  }, [setNotificationContentOverride, cashToCloseContextText])

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://payload.com/Payload.js'

    document.head.appendChild(script)

    // Clean up when component unmounts
    return () => {
      document.head.removeChild(script)
    }
  }, [])

  if (!notification || getPayloadMetaDataLoading) return <LoadingScreen/>

  return (
    <PayloadProcessingStateProvider>
      <Box sx={{width: '100%', maxWidth: '700px'}}>
        { pastDue &&
          <Alert severity="error" sx={{ mb: 3 }}>
            This task is past due. Online payments can no longer be accepted.
          </Alert>
        }
        <CashToCloseTransactionsSummary expandedByDefault={!notification.IsComplete && !pastDue}/>
        { shouldInitiatePayment && !pastDue &&
          <Box mb={2}>
            <CashToCloseEnterMoreOrComplete/> 
          </Box>
        }
      </Box>
    </PayloadProcessingStateProvider>
  )
}

